

import css from './CountButton.module.css';
import componentFunctions from '../../../../../services/tools/componentFunctions';


function CountButton({ sortedAndFilteredData, onClick }) {
    return (
        <div
            className={sortedAndFilteredData.length === 0 ? `${css.filterCount} ${css.filterCountZero}` : css.filterCount}
            style={{ cursor: 'pointer' }}
            onClick={() => componentFunctions.downloadCSV(sortedAndFilteredData, `tna_${componentFunctions.getToday()}.csv`)}
        >
            {' '}
            {sortedAndFilteredData.length}{' '}
        </div>
    );
}

export default CountButton;
